import React from 'react';
import { Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  button: {
    whiteSpace: 'nowrap',
    textTransform: 'none',
    padding: theme.spacing(0),
    color: theme.palette.text.primary,
    '&:hover': {
      background: 'transparent'
    }
  },
  period: {
    fontSize: theme.typography.h6.fontSize,
    fontWeight: theme.typography.h6.fontWeight,
    display: 'flex',
    alignItems: 'center',
    padding: `${0} ${theme.spacing(5)} 0 ${theme.spacing(0.5)}`,
    color: theme.palette.text.primary
  }
}));

type InsightDateRangeLabelProps = {
  label: string;
};

const InsightDateRangeLabel: React.FC<InsightDateRangeLabelProps> = ({
  label
}: InsightDateRangeLabelProps) => {
  const classes = useStyles();

  return (
    <>
      <div
        data-testid="insights-date-range-picker-btn"
        className={classes.button}
      >
        <Typography
          className={classes.period}
          data-testid="insights-date-range-string"
        >
          {label}
        </Typography>
      </div>
    </>
  );
};

export default React.memo(InsightDateRangeLabel);
